<template>
  <div class="activity-box">
    <img :src="src" alt="" />
  </div>
</template>
<script>
export default {
  name: 'ActivityStatic',
  props: {
    src: String
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  height: 100vh;
  overflow: auto;
  img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
